import { GOALS_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

import type { FieldTransformer } from '../types/transformer-type.tsx';
import { transformAggNodeToLegacyField } from './default-node-transformer.tsx';

export const transformAggGoalsToLegacyField: FieldTransformer<typeof GOALS_CF_TYPE> = (node) => {
	if (node.type !== GOALS_CF_TYPE) return undefined;

	const isShowAllGoals =
		// eslint-disable-next-line jira/ff/no-preconditioning
		fg('jira-preview-panel-goals-integration') &&
		fg('jira_preview_panel_m_1_rollout') &&
		fg('jira-glance-panel');
	const activeSelectedGoals = isShowAllGoals ? node.selectedGoalsShowAllGoals : node.selectedGoals;

	const value = activeSelectedGoals
		? {
				goals:
					activeSelectedGoals?.edges
						?.filter((edge) => edge?.node !== null)
						.map((edge) => {
							const transformedNode = edge?.node;
							const result = {
								id: transformedNode?.id || '',
								name: transformedNode?.name || '',
								status: transformedNode?.status || null,
							};

							// Include key for multi-goal case (key field is only available in selectedGoalsShowAllGoals)
							if (isShowAllGoals && transformedNode) {
								const nodeWithKey = transformedNode;
								// @ts-expect-error TODO JPX-157
								if (nodeWithKey.key) {
									// @ts-expect-error TODO JPX-157
									result.key = nodeWithKey.key;
								}
							}

							return result;
						}) || [],
				totalCount: activeSelectedGoals?.totalCount || 0,
			}
		: null;

	return {
		...transformAggNodeToLegacyField(node),
		value,
		schema: {
			configuration: null,
			custom: GOALS_CF_TYPE,
			items: null,
			renderer: null,
			system: null,
			type: GOALS_CF_TYPE,
		},
	};
};
